/* Lead tracking (Move 3): records the steps visitors take towards becoming a lead.
   Events go to whatever is connected: Shopify customer events, Google Analytics/Tag Manager,
   Hotjar and LogRocket. Nothing personal is sent, only the event name, page and link. */

(function () {
  function send(name, detail) {
    var data = Object.assign({ page: location.pathname }, detail || {});
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('cd_' + name, data);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', 'cd_' + name, data);
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'cd_' + name }, data));
    } catch (e) {}
    try {
      if (typeof window.hj === 'function') window.hj('event', 'cd_' + name);
    } catch (e) {}
    try {
      if (window.LogRocket && window.LogRocket.track) window.LogRocket.track('cd_' + name, data);
    } catch (e) {}
  }

  function classify(href) {
    if (/calendly\.com/i.test(href)) return 'book_call_click';
    if (/\/pages\/free-audit|^#request$/i.test(href)) return 'audit_click';
    if (/\/pages\/(packages|pricing)/i.test(href)) return 'pricing_click';
    if (/\/pages\/approval-pack/i.test(href)) return 'approval_pack_click';
    if (/\/pages\/care-plan/i.test(href)) return 'care_plan_click';
    if (/^mailto:/i.test(href)) return 'email_click';
    return null;
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cd-print]')) {
      send('approval_pack_saved');
      return;
    }
    var link = event.target.closest('a[href]');
    if (!link) return;
    var name = classify(link.getAttribute('href'));
    if (!name) return;
    var source = link.closest('[data-cd-source]');
    send(name, { link: link.getAttribute('href').split('?')[0], source: source ? source.dataset.cdSource : undefined });
  });

  // Offer page interactions (cd-hww-interact.js) report their steps here.
  document.addEventListener('cd:track', function (event) {
    send(event.detail.name, event.detail.data);
  });

  // A form that was just sent renders a success message carrying the event name.
  function reportSuccess() {
    document.querySelectorAll('[data-cd-event]').forEach(function (el) {
      if (el.dataset.cdEvent) send(el.dataset.cdEvent);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reportSuccess);
  else reportSuccess();
})();
